import React from "react";
import { Item } from "semantic-ui-react";
import { DocumentListEntry } from "@modules/Document/DocumentListEntry";
import SeriesListEntry from "@modules/Series/SeriesListEntry";
import SpecialCollectionListEntry from "@modules/SpecialCollections/SpecialCollectionListEntry";
import { recordToPidType } from "@api/utils";
import PropTypes from "prop-types";

export const LiteratureSearchResultsList = ({ results, overridableId }) => {
  return results && results.length ? (
    <Item.Group>
      {results.map((result) => {
        const pidType = recordToPidType(result);

        if (pidType === "docid") {
          return (
            <DocumentListEntry
              key={result.metadata.pid}
              data-test={result.metadata.pid}
              metadata={result.metadata}
            />
          );
        } else if (pidType === "serid") {
          return (
            <SeriesListEntry
              key={result.metadata.pid}
              data-test={result.metadata.pid}
              metadata={result.metadata}
            />
          );
        } else if (pidType === "scolid") {
          return (
            <SpecialCollectionListEntry
              key={result.metadata.pid}
              data-test={result.metadata.pid}
              metadata={result.metadata}
            />
          );
        } else {
          // Fallback for unknown pid types - shouldn't happen but good to have
          console.warn(`Unknown pid type: ${pidType} for record:`, result);
          return (
            <DocumentListEntry
              key={result.metadata.pid}
              data-test={result.metadata.pid}
              metadata={result.metadata}
            />
          );
        }
      })}
    </Item.Group>
  ) : null;
};

LiteratureSearchResultsList.propTypes = {
  results: PropTypes.array.isRequired,
  overridableId: PropTypes.string,
};

LiteratureSearchResultsList.defaultProps = {
  overridableId: "",
};
